module.exports = __webpack_public_path__ + "public/SiteIcons/viewListingShareIcon.svg?47e5af78";